import { FileUploader } from "react-drag-drop-files";

const FileUploaderNBK = (props) => {
  const { onFileDrop, file } = props;

  return (
    <FileUploader
      handleChange={onFileDrop}
      name="file"
      types={["txt"]}
      maxSize={1}
      multiple
    >
      <div
        style={{
          border: "1px dashed rgb(16, 163, 127)",
          marginBottom: "24px",
          padding: "12px 16px",
          borderRadius: "4px",
          backgroundColor: "rgba(16, 163, 127, 0.25)",
        }}
      >
        <p>
          {file
            ? `Fichier ${file.name} prêt à être envoyé`
            : "Déposer le fichier à adapter"}
        </p>
      </div>
    </FileUploader>
  );
};

export default FileUploaderNBK;
